module.exports = __webpack_public_path__ + "assets/img/bde73be25c25a81d84fd07e318ffe862.png";